import { ConcealedDuctLocationType, LevelType } from 'data/types';
import { isLevelConditioned } from 'utils/level-conditioning';

export const CONCEALED_DUCT_RUN_WORLD_HEIGHT = 2.4;

const ATTIC_DUCT_RUN_WORLD_HEIGHT = 2.645;
const BASEMENT_DUCT_RUN_WORLD_HEIGHT = -0.13;
const ATTIC_UNIT_WORLD_Y = 2.67;
const BASEMENT_UNIT_WORLD_Y = -0.16;

export type ConcealedDuctPlacementOptions = {
  attic: boolean;
  basement: boolean;
};

function isUnconditionedLevelOfType(
  level: LevelType | undefined,
  type: 'attic' | 'basement'
): boolean {
  return !!level && level.type === type && !isLevelConditioned(level);
}

export function getConcealedDuctPlacementOptions(
  originLevelIndex: number,
  structure: LevelType[]
): ConcealedDuctPlacementOptions {
  if (originLevelIndex < 0 || originLevelIndex >= structure.length) {
    return { attic: false, basement: false };
  }
  return {
    attic: isUnconditionedLevelOfType(structure[originLevelIndex + 1], 'attic'),
    basement: isUnconditionedLevelOfType(
      structure[originLevelIndex - 1],
      'basement'
    )
  };
}

export function resolveConcealedDuctLocation(
  storedLocation: ConcealedDuctLocationType | null | undefined,
  originLevelIndex: number,
  structure: LevelType[]
): ConcealedDuctLocationType | null {
  const options = getConcealedDuctPlacementOptions(originLevelIndex, structure);
  if (options.attic && options.basement) {
    return storedLocation ?? 'attic';
  }
  if (options.attic) return 'attic';
  if (options.basement) return 'basement';
  return null;
}

export function getConcealedDuctPlacementLevelIndex(
  originLevelIndex: number,
  location: ConcealedDuctLocationType | null | undefined
): number {
  if (location === 'attic') return originLevelIndex + 1;
  if (location === 'basement') return originLevelIndex - 1;
  return originLevelIndex;
}

export function getConcealedDuctRunWorldHeight(
  location: ConcealedDuctLocationType | null | undefined
): number {
  if (location === 'attic') {
    return ATTIC_DUCT_RUN_WORLD_HEIGHT;
  }
  if (location === 'basement') {
    return BASEMENT_DUCT_RUN_WORLD_HEIGHT;
  }
  return CONCEALED_DUCT_RUN_WORLD_HEIGHT;
}

export function getConcealedDuctUnitWorldY(
  location: ConcealedDuctLocationType | null | undefined
): number {
  if (location === 'attic') {
    return ATTIC_UNIT_WORLD_Y;
  }
  if (location === 'basement') {
    return BASEMENT_UNIT_WORLD_Y;
  }
  return CONCEALED_DUCT_RUN_WORLD_HEIGHT;
}
